<template>
	<div>
		<statistics-partials-plain partial-title="Score" :partial-value="roundScoring.score"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Score Literal" :partial-value="roundScoring.score_literal"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Albatrosses" :partial-value="roundScoring.albatrosses"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Eagles" :partial-value="roundScoring.eagles"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Birdies" :partial-value="roundScoring.birdies"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Pars" :partial-value="roundScoring.pars"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Bogeys" :partial-value="roundScoring.bogeys"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Double Bogeys" :partial-value="roundScoring.double_bogeys"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Triple+" :partial-value="roundScoring.triple_or_worse"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 3 Scores" :partial-value="roundScoring.par_3_scores"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 4 Scores" :partial-value="roundScoring.par_4_scores"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 5 Scores" :partial-value="roundScoring.par_5_scores"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Penalties" :partial-value="roundScoring.penalties"></statistics-partials-plain>
	</div>
</template>
<script>
export default {
	name: "StatisticsScoring",
	props: {
		roundScoring: {
			type: Object,
			required: true
		}
	},
	components: {
		'statistics-partials-plain': () => import(/* webpackChunkName: "StatisticsFairways" */ './Partials/Plain'),
	}
}
</script>
